/**
 * Mobile autoplay for Text with icons (scroll-carousel).
 * Only runs at sm-max when the carousel has an autoplay attribute (seconds).
 */
(() => {
  const MOBILE_QUERY = '(max-width: 699px)';

  function setup(carousel) {
    if (carousel.__textWithIconsAutoplay) return;

    const seconds = Number.parseFloat(carousel.getAttribute('autoplay'));
    if (!(seconds > 0)) return;

    carousel.__textWithIconsAutoplay = true;

    const mobile = window.matchMedia(MOBILE_QUERY);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer = null;
    let inView = false;
    let pausedByUser = false;

    function clear() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function advance() {
      if (!carousel.isScrollable || carousel.cells.length < 2) return;

      if (carousel.selectedIndex >= carousel.cells.length - 1) {
        carousel.select(0);
      } else {
        carousel.next();
      }
    }

    function sync() {
      clear();

      if (!mobile.matches || reduceMotion.matches || !inView || pausedByUser) return;
      if (!carousel.isScrollable || carousel.cells.length < 2) return;

      timer = window.setInterval(advance, seconds * 1000);
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        inView = Boolean(entry?.isIntersecting);
        sync();
      },
      { threshold: 0.35 }
    );
    observer.observe(carousel);

    const pause = () => {
      pausedByUser = true;
      sync();
    };

    const resume = () => {
      pausedByUser = false;
      sync();
    };

    carousel.addEventListener('pointerdown', pause);
    carousel.addEventListener('touchstart', pause, { passive: true });
    carousel.addEventListener('pointerleave', resume);
    carousel.addEventListener('touchend', resume, { passive: true });

    mobile.addEventListener('change', sync);
    reduceMotion.addEventListener('change', sync);
    sync();
  }

  function init() {
    document.querySelectorAll('scroll-carousel.text-with-icons[autoplay]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
